import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  images: [],
  videos: [],
  comments: [], 
  totalUploads: 0,
  lastUpload: null,
};

const uploadedContentSlice = createSlice({
  name: 'uploadedContent',
  initialState,
  reducers: {
    setUploadedContent: (state, action) => {
      state.images = action.payload.images || [];
      state.videos = action.payload.videos || [];
      state.comments = action.payload.comments || [];
      state.totalUploads = state.images.length + state.videos.length + state.comments.length;

      const allItems = [...state.images, ...state.videos, ...state.comments].sort(
        (a, b) => new Date(b.uploadedAt || 0) - new Date(a.uploadedAt || 0)
      );
      state.lastUpload = allItems[0] || null;
    },
    addImage: (state, action) => {
      const newImage = {
        id: action.payload.id || Date.now().toString(),
        type: 'image',
        url: action.payload.url,
        thumbUrl: action.payload.thumbUrl ?? null,
        name: action.payload.name,
        size: action.payload.size,
        uploadedAt: action.payload.uploadedAt || new Date().toISOString(),
        eventCode: action.payload.eventCode,
        guestName: action.payload.guestName ?? null,
        guestPhone: action.payload.guestPhone ?? null,
      };
      state.images.push(newImage);
      state.totalUploads += 1;
      state.lastUpload = newImage;
    },
    
    addVideo: (state, action) => {
      const newVideo = {
        id: action.payload.id || Date.now().toString(),
        type: 'video',
        url: action.payload.url,
        thumbUrl: action.payload.thumbUrl ?? null,
        name: action.payload.name,
        size: action.payload.size,
        uploadedAt: action.payload.uploadedAt || new Date().toISOString(),
        eventCode: action.payload.eventCode,
        guestName: action.payload.guestName ?? null,
        guestPhone: action.payload.guestPhone ?? null,
      };
      state.videos.push(newVideo);
      state.totalUploads += 1;
      state.lastUpload = newVideo;
    },
    addComment: (state, action) => {
      const newComment = {
        id: Date.now().toString(),
        type: 'comment',
        text: action.payload.text,
        uploadedAt: new Date().toISOString(),
        eventCode: action.payload.eventCode,
        guestName: action.payload.guestName ?? null,
        guestPhone: action.payload.guestPhone ?? null,
      };
      state.comments.push(newComment);
      state.totalUploads += 1;
      state.lastUpload = newComment;
    },
    addCommentToShow: (state, action) => {
      const newComment = {
        id: action.payload.id || Date.now().toString(),
        type: 'comment',
        text: action.payload.text,
        uploadedAt: action.payload.uploadedAt || new Date().toISOString(),
        eventCode: action.payload.eventCode ?? null,
        guestName: action.payload.guestName ?? null,
        guestPhone: action.payload.guestPhone ?? null,
      };
      state.comments.push(newComment);
      state.totalUploads += 1;
      state.lastUpload = newComment;
    },
    removeContent: (state, action) => {
      const { id, type } = action.payload;
      if (type === 'image') {
        state.images = state.images.filter(img => img.id !== id);
      } else if (type === 'video') {
        state.videos = state.videos.filter(video => video.id !== id);
      } else if (type === 'comment') {
        state.comments = state.comments.filter(comment => comment.id !== id);
      }
      state.totalUploads = state.images.length + state.videos.length + state.comments.length;
    },
    clearAllContent: (state) => {
      state.images = [];
      state.videos = [];
      state.comments = [];
      state.totalUploads = 0;
      state.lastUpload = null;
    },
  },
});

// Selectors
export const selectAllImages = (state) => state.uploadedContent.images;
export const selectAllVideos = (state) => state.uploadedContent.videos;
export const selectAllComments = (state) => state.uploadedContent.comments;
export const selectTotalUploads = (state) => state.uploadedContent.totalUploads;
export const selectLastUpload = (state) => state.uploadedContent.lastUpload;
export const selectContentByEvent = (state, eventCode) => {
  const content = state.uploadedContent;
  return {
    images: content.images.filter(img => img.eventCode === eventCode),
    videos: content.videos.filter(video => video.eventCode === eventCode),
    comments: content.comments.filter(comment => comment.eventCode === eventCode),
  };
};

export const { 
  setUploadedContent,
  addImage, 
  addVideo, 
  addComment, 
  removeContent, 
  clearAllContent,
  addCommentToShow
} = uploadedContentSlice.actions;

export default uploadedContentSlice.reducer; 